var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('router-view'),_c('a',{staticClass:"icp-footer",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("湘ICP备2026047063号")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }